import { BASE_URL } from "@api/constant";
import {
  FB_APP_ID,
  IOS_APP_STORE_ID,
  ITUNES_APP,
  OG_IMAGE,
  OG_SITE_NAME,
  ROBOTS,
} from "@config/MetaTagsConstants";
import type { GADataProps } from "@helper/getGtmData";
import { MetaTagsProps } from "@sphtech/web2-seo-schema";
import type { PageMetaDataValues } from "@typings/PageMetaData";

export default function QuizMetaData(sectionName: string): PageMetaDataValues {
  const level2 = sectionName.replace("-", " ");

  const metaTitle =
    "முரசு சொல்லாட்டம் | பொது அறிவு & பொழுதுபோக்கு க்விஸ் - தமிழ்முரசு";
  const metaDesc =
    "தமிழ்முரசு சொல்லாட்டம் - பொது அறிவு, வரலாறு, சினிமா, விளையாட்டு, மற்றும் பல தொழில்நுட்பக் கேள்விகளுடன் உங்கள் அறிவை சோதிக்கவும். உடனே விளையாடுங்கள்!";

  const ogImage: string = new URL(OG_IMAGE, BASE_URL).toString();

  const additionalMetaDescriptors = [
    { tagName: "link", rel: "manifest", href: "/manifest.json" },
  ];

  const metaTags: MetaTagsProps = {
    title: metaTitle,
    description: metaDesc,
    slug: sectionName,
    keywords: [
      "முரசு சொல்லாட்டம்",
      "தினசரி வினாடி வினா",
      "Word Quiz",
      "Daily Quiz",
      "Tamil Quiz",
      "Tamil Word Quiz",
      "தமிழ் வினாடி வினா",
      "Tamil trivia",
      "தமிழ் பொழுதுபோக்கு",
      "தமிழ் கல்வி",
    ],
    robots: ROBOTS,
    fbAppId: FB_APP_ID,
    iosAppStoreId: IOS_APP_STORE_ID,
    appleItunesAppId: ITUNES_APP,
    urlOrigin: BASE_URL,
    ogTitle: metaTitle,
    image: ogImage,
    ogDescription: metaDesc,
    ogSiteName: OG_SITE_NAME,
    additionalMetaDescriptors,
  };

  const gaData: GADataProps = {
    level2: level2,
    title: `${sectionName.replace("-", "_")}_index`,
    contentcat: 1,
    contenttype: undefined,
  };

  return {
    gaData,
    metaTags,
  };
}
